import { render, staticRenderFns } from "./rework.vue?vue&type=template&id=efc0a4fc&scoped=true"
import script from "./rework.vue?vue&type=script&lang=js"
export * from "./rework.vue?vue&type=script&lang=js"
import style0 from "./rework.vue?vue&type=style&index=0&id=efc0a4fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc0a4fc",
  null
  
)

export default component.exports